import { TextField } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import S3FilesAndImagesDialog from "@saleor/s3/components";
import React, { useState } from "react";
// S3图片上传组件

interface S3TextFieldProps {
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  name?: string;
  onChange?: (event: React.ChangeEvent<any>) => void;
  label?: string;
  value?: string;
  setNameValue?: (name, value) => void;
}

const S3TextField: React.FC<S3TextFieldProps> = props => {
  const {
    disabled,
    error,
    helperText,
    name,
    onChange,
    label,
    value,
    setNameValue
  } = props;

  const [s3open, setS3Open] = useState(false);
  const [currentS3Media, setcurrentS3Media] = useState("");
  const [currentS3MediaType, setCurrentS3MediaType] = useState("image");

  const [inputMedia, setInputMedia] = useStateFromProps(value);

  // 选择更新视频或图片素材
  const loadS3Media = () => {
    const src_url = inputMedia;
    if (
      src_url.indexOf(".jpg") > 0 ||
      src_url.indexOf(".png") > 0 ||
      src_url.indexOf(".gif") > 0 ||
      src_url.indexOf(".webp") > 0
    ) {
      setCurrentS3MediaType("image");
    } else if (src_url.indexOf(".mp4") > 0) {
      setCurrentS3MediaType("video");
    }
    setcurrentS3Media(src_url);
    setS3Open(true);
  };

  const onSelectEvent = value => {
    setInputMedia(value); // 重新渲染
    setNameValue(name, value); // 更新到form的data
  };

  const onChangeEvent = event => {
    const { value } = event.target;
    setInputMedia(value); // 重新渲染
    onChange(event);
  };

  return (
    <>
      <p
        style={{
          clear: "both",
          width: "100%",
          display: "block",
          margin: "0px"
        }}
      >
        <TextField
          disabled={disabled}
          error={error}
          helperText={helperText}
          name={name as keyof FormData}
          onChange={onChangeEvent}
          label={label}
          value={inputMedia}
          style={{ width: "80%" }}
        />
        <CloudUploadIcon
          style={{
            marginLeft: 20,
            width: 40,
            height: 40,
            cursor: "pointer"
          }}
          color="primary"
          onClick={loadS3Media}
        />

        {s3open && (
          <S3FilesAndImagesDialog
            open={s3open}
            onClose={() => {
              setS3Open(false);
            }}
            defaultCurrentS3Media={"color"}
            setShowS3Media={setS3Open}
            currentS3Media={currentS3Media}
            currentS3MediaType={currentS3MediaType}
            onSelectS3Media={onSelectEvent}
          />
        )}

        {inputMedia && (
          <>
            <br />
            <img
              src={inputMedia}
              style={{
                height: "100px",
                marginTop: "20px",
                overflow: "hidden",
                objectFit: "cover"
              }}
            />
          </>
        )}
      </p>
    </>
  );
};
S3TextField.displayName = "S3TextField";
export default S3TextField;
